import React, {createContext, ReactNode, useContext, useReducer} from 'react';
import {reducer, initialState, UserInfoState} from './reducers/userInfoReducer';
export {actionTypes as userInfoActionTypes} from './reducers/userInfoReducer';

type UserInfoStateContext = {state: UserInfoState; dispatch: React.Dispatch<any>};

const UserInfoContext = createContext<UserInfoStateContext>({} as UserInfoStateContext);

export default function UserInfoStateProvider({children}: {children: ReactNode}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <UserInfoContext.Provider value={{state, dispatch}}>{children}</UserInfoContext.Provider>;
}

export const useUserInfoState = () => {
  const context = useContext(UserInfoContext);
  if (context === undefined) {
    throw new Error('useUserInfoState must be within UserInfoProvider');
  }

  return context;
};
